import {Text, View} from 'react-native';
import React from 'react';


const EabuServices = () => {

return(
  <>
    <View style={styles.infoSection}>
      <Text style={styles.infoTitle}>Services you can Use or Deliver Through Eabu:</Text>

      <View style={styles.infoItem}>
        <Text style={styles.infoIcon}>🍲</Text>
        <View style={styles.infoTextContainer}>
          <Text style={styles.infoSubtitle}>Food Service</Text>
          <Text style={styles.infoDescription}>
            Catering and cooking delicious dishes from your home kitchen as per requests from local communities.
          </Text>
        </View>
      </View>

      <View style={styles.infoItem}>
        <Text style={styles.infoIcon}>🧹</Text>
        <View style={styles.infoTextContainer}>
          <Text style={styles.infoSubtitle}>Household Help</Text>
          <Text style={styles.infoDescription}>
            Assistance with cleaning, lawn care, grocery shopping, and various other daily needs.
          </Text>
        </View>
      </View>

      <View style={styles.infoItem}>
        <Text style={styles.infoIcon}>🚚</Text>
        <View style={styles.infoTextContainer}>
          <Text style={styles.infoSubtitle}>Moving & Transport</Text>
          <Text style={styles.infoDescription}>
            Help with moving in/out, ride-sharing, and general transportation support.
          </Text>
        </View>
      </View>
    </View>
  </>
  );

};

const styles = {
  screen: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  successBanner: {
    flexDirection: 'row',
    backgroundColor: '#E8F5E9',
    margin: 16,
    padding: 16,
    borderRadius: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#4CAF50',
    elevation: 2,
  },
  processingBanner: {
    flexDirection: 'row',
    backgroundColor: '#E3F2FD',
    margin: 16,
    padding: 16,
    borderRadius: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#2196F3',
    elevation: 2,
  },
  verificationCard: {
    backgroundColor: '#FFF',
    margin: 16,
    padding: 20,
    borderRadius: 12,
    elevation: 2,
  },
  successIcon: {
    fontSize: 24,
    color: '#4CAF50',
    marginRight: 12,
  },
  processingIcon: {
    fontSize: 24,
    marginRight: 12,
  },
  bannerContent: {
    flex: 1,
  },
  successTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2E7D32',
    marginBottom: 4,
  },
  successMessage: {
    color: '#388E3C',
  },
  processingTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1565C0',
    marginBottom: 4,
  },
  processingMessage: {
    color: '#1976D2',
  },
  verificationTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#263238',
    marginBottom: 8,
  },
  verificationDescription: {
    color: '#546E7A',
    marginBottom: 16,
    lineHeight: 20,
  },
  verifyButton: {
    backgroundColor: '#2196F3',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    borderRadius: 8,
    elevation: 2,
  },
  verifyButtonPressed: {
    backgroundColor: '#1976D2',
  },
  verifyButtonText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: '600',
    marginRight: 8,
  },
  verifyButtonArrow: {
    color: '#FFF',
    fontSize: 18,
  },
  progressBar: {
    height: 4,
    backgroundColor: '#BBDEFB',
    borderRadius: 2,
    marginTop: 8,
    overflow: 'hidden',
  },
  progressFill: {
    width: '30%',
    height: '100%',
    backgroundColor: '#2196F3',
    borderRadius: 2,
  },
  content: {
    opacity: 1,
  },
  disabledContent: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
  infoSection: {
    marginTop: 24,
    marginHorizontal: 16,
    padding: 20,
    backgroundColor: '#fff',
    borderRadius: 12,
    elevation: 2,
  },
  infoTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#333',
    marginBottom: 16,
    textAlign: 'center',
  },
  infoItem: {
    flexDirection: 'row',
    marginBottom: 16,
    alignItems: 'flex-start',
  },
  infoIcon: {
    fontSize: 24,
    marginRight: 12,
    marginTop: 2,
  },
  infoTextContainer: {
    flex: 1,
  },
  infoSubtitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#444',
    marginBottom: 4,
  },
  infoDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
};

export default EabuServices;
